import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Topbar from '@/components/layout/Topbar';
import { api } from '@/lib/api';
import CandidateCard from '@/components/CandidateCard';

const FILTERS = [
  { id: 'todas', label: 'Todas' },
  { id: 'cerrada', label: 'Cerradas' },
  { id: 'shadow', label: 'Shadow' },
  { id: 'rechazada_tribunal', label: 'Rech. tribunal' },
  { id: 'rechazada_comite', label: 'Rech. comité' },
  { id: 'rechazada_jorge', label: 'Rech. Jorge' },
  { id: 'rechazada_riesgo', label: 'Rech. riesgo' },
];

export default function Historial() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('todas');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/history');
      setItems(data.historial || []);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = useMemo(
    () => filter === 'todas' ? items : items.filter((c) => c.estado === filter),
    [items, filter]
  );

  return (
    <>
      <Topbar title="Historial" subtitle={`${items.length} candidatas registradas`} />
      <div className="px-3 sm:px-4 lg:px-6 py-4">
        <div className="flex items-center gap-2 flex-wrap mb-3">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              data-testid={`filter-${f.id}`}
              className={`text-xs px-3 py-1.5 rounded-full border ${filter === f.id ? 'bg-[hsl(var(--brand))]/15 border-[hsl(var(--brand))]/40 text-[hsl(var(--brand))]' : 'bg-muted border-border text-muted-foreground'}`}
            >{f.label}</button>
          ))}
        </div>
        {loading && <div className="panel p-4 text-sm text-muted-foreground">Cargando historial...</div>}
        {!loading && filtered.length === 0 && <div className="panel p-6 text-sm text-muted-foreground text-center" data-testid="empty-history">Sin operaciones para este filtro.</div>}
        <div className="space-y-3">
          {filtered.map((c) => <CandidateCard key={c.candidata_id} candidata={c} onChanged={load} />)}
        </div>
      </div>
    </>
  );
}
